// import state from './state'
// import * as getters from './getters'
// import * as mutations from './mutations'
// import * as actions from './actions'
import sample from '../Api/sample'

// initial state
const state = {
  sample: null
}

// getters
const getters = {
  sample: (state, getters) => {
    return state.sample
  }
}

// mutations
const mutations = {
  SET_SAMPLE (state, sample) {
    state.sample = sample
  }
}

// actions
const actions = {
  async setSample (context) {
    const result = await sample.get()
    context.commit('SET_SAMPLE', result.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
